import React, { createContext, useContext } from "react";
import AxL from "./axl";

// Create a context for AxL
const axl = new AxL();
const AxLContext = createContext(axl);

// Custom hook to access AxL
export function useAxL() {
  const axl = useContext(AxLContext);
  if (!axl) {
    throw new Error("useAxL must be used within an AxLProvider");
  }
  return axl;
}

// AxLProvider component to wrap your app with
export function AxLProvider({ children }) {
  return <AxLContext.Provider value={axl}>{children}</AxLContext.Provider>;
}
